import React from "react";
import "./location.css";
import { useNavigate } from "react-router-dom";

function Location() {
  const navigate = useNavigate();

  const destinations = [
    {
      name: "Sigiriya Rock Fortress",
      img: "/sigiriya.jpg",
       path: "/booking",
      desc: "Ancient UNESCO World Heritage site with breathtaking sky-high views and royal history.",
      tag: "Best time: Early morning | Culture • History",
    },
    {
      name: "Kandy",
      img: "/kandy.webp",
       path: "/booking",
      desc: "The cultural capital, home to the sacred Temple of the Tooth and scenic lake views.",
      tag: "Best time: Evening walks | Culture • Heritage",
    },
    {
      name: "Ella",
      img: "/ella.jpg",
       path: "/booking",
      desc: "Misty mountains, tea plantations, and one of the world's most scenic train journeys.",
      tag: "Best time: Morning hikes | Nature • Adventure",
    },
    {
      name: "Galle Fort",
      img: "/gallefort.jpg",
        path: "/booking",
      desc: "A colonial fort city surrounded by ocean views, cafes, and cobblestone streets.",
      tag: "Best time: Sunset | History • Coastal",
    },
    {
      name: "Mirissa Beach",
      img: "/mirissa.jpg",
        path: "/booking",
      desc: "Golden beaches, whale watching, and calm tropical ocean vibes.",
      tag: "Best time: Nov–Apr | Beach • Relax",
    },
    {
      name: "Nuwara Eliya",
      img: "/nuwara-eliya.jpg",
       path: "/booking",
      desc: "Cool climate, tea estates, waterfalls, and colonial charm.",
      tag: "Best time: April season | Hills • Nature",
    },

     {
    name: "Sinharaja",
    img: "/sinharaja.webp",
     path: "/booking",
    desc: "UNESCO World Heritage rainforest, home to endemic birds, butterflies, and breathtaking biodiversity beneath a lush green canopy.",
    tag: "Best time: Jan–Mar & Aug–Sep | Rainforest • Wildlife",
  },
  {
    name: "Yala",
    img: "/yala.jpg",
      path: "/booking",
    desc: "Sri Lanka's most famous wildlife park with the world's highest leopard density, plus elephants, crocodiles, and stunning coastal scenery.",
    tag: "Best time: Feb–Jun | Safari • Wildlife",
  },
  {
    name: "Unawatuna",
    img: "/unawatuna.jpg",
      path: "/booking",
    desc: "Tropical paradise with crescent-shaped golden sand, turquoise waters, vibrant coral reefs, and a relaxed beach town atmosphere.",
    tag: "Best time: Nov–Mar | Beach • Snorkeling",
  },
  {
    name: "Polonnaruwa",
    img: "/polonnaruwa.jpg",
    path: "/booking",
    desc: "Ancient capital with magnificently preserved medieval ruins, colossal stone statues, and impressive irrigation reservoirs from the 12th century.",
    tag: "Best time: Year-round | Heritage • Culture",
  },
  {
    name: "Arugam Bay",
    img: "/arugam-bay.jpg",
    path: "/booking",
    desc: "World-renowned surf destination with consistent point breaks, laid-back vibe, palm-fringed beaches, and amazing sunsets over the Indian Ocean.",
    tag: "Best time: Apr–Sep | Surfing • Beach",
  },
  {
    name: "Horton Plains",
    img: "/horton plains.jpg",
    path: "/booking",
    desc: "Magical cloud forest with the famous \"World's End\" sheer cliff drop, stunning Baker's Falls, rare birds, and surreal highland landscapes.",
    tag: "Best time: Jan–Mar | Trekking • Nature",
  },
  ];

  return (
    <div className="location-page">
      
      {/* HERO */}
<section
  className="location-hero"
  style={{
    backgroundImage: `url('/bannerceylonwayfinder.png')`
  }}
>
  <div className="overlay"></div>

  <div className="hero-content">
    <h1>
      Discover <span>Sri Lanka</span>
    </h1>

    <p>Luxury travel destinations with premium taxi service</p>

    <button
      className="hero-btn"
      onClick={() => navigate("/booking")}
    >
      Book a Ride
    </button>
  </div>
</section>

      {/* DESTINATIONS */}
      <section className="destinations">
        <div className="container">
          <div className="section-header">
            <h2>Top Destinations</h2>
            <p>Explore the most iconic places across the island</p>
          </div>

          <div className="grid">
            {destinations.map((item, index) => (
              <div
                key={index}
                className="card"
                onClick={() => navigate(item.path)}
              >
                <div className="img-wrapper">
                  <img src={item.img} alt={item.name} />
                </div>

                <div className="card-content">
                  <h3>{item.name}</h3>
                  <p>{item.desc}</p>
                  <small>{item.tag}</small>
                  <span className="link">Book Now →</span>
                </div>
              </div>
            ))}
          </div>






        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="cta-box">
          <h2>Ready to Travel?</h2>
          <p>Book your premium taxi service with Ceylon Wayfinder</p>

          <button onClick={() => navigate("/booking")}>
            Book Now
          </button>
        </div>
      </section>

    </div>
  );
}

export default Location;